/* eslint-disable max-len */
const UploadDocument = () => import(/* webpackChunkName: "UploadDocument" */ '@/components/upload-document');
import ModalActions from '@/inheritance/modal-actions';
import documentsService from '../../../../plugin/services/documents.service';

export default {
    name: 'relatedDocumentation',

    /**
     * Extendemos la funcionalidad de los modals desde src/inheritance/modal-actions.js
     */
    extends: ModalActions,

    /**
     * @override
     */
    data() {
        return {
            documentToDelete: null,
            files: [],
            loading: false,
            uploadDocument: false,
            uuid_account: null,
            typeDocumentation: null,
            linkMoreInformation: 'account_documentation_uuid_view',
            activeDownloads: []
        };
    },

    props: {
        limit: {
            type: Number,
            required: false
        },
        id: {
            type: String,
            required: true
        },
        type: {
            type: String,
            required: false
        },
        entityStatus: {
            type: String,
            required: false
        }
    },

    components: {
        UploadDocument
    },

    methods: {
        handleDocumentDeletion(row) {
            this.showModal('modalRemoveDocument');
            this.assignIdDocumentToDelete(row.item);
        },
        /**
         * Obtenemos la información relativa a la documentación de la cuenta
         */
        fetchData() {
            this.loading = true;

            const cfg = {};
            cfg.params = {};
            if (this.limit) {
                cfg.params.$limit = this.limit;
            }
            const documentationTypeToServiceMap = {
                intervener: this.$intervenersService.getIntervenerDocuments,
                account: this.$accountsService.getAccountDocuments,
                operation: this.$operationsService.getOperationDocuments
            };
            documentationTypeToServiceMap[this.typeDocumentation](this.id, cfg)
                .then(res => {
                    const documents = res.data.accounts_documents || res.data.intervener_documents || res.data.operations_documents || [];
                    this.files.items = documents.filter(document => document.key_subcategory !== 'VIDEOIDENTIFICACION');
                })
                .catch(err => {
                    this.$toast.error(`Error ${err.name}`, `${err.message}`);
                    console.error(err);
                })
                .finally(() => this.loading = false);
        },

        /**
         * Link a documento
         * @param {String} uuid_document id del documento
         * @param {String} fileName nombre del documento
         */
        linkDocument(uuid_document, fileName) {
            this.activeDownloads.push(uuid_document);
            documentsService.get(this.typeDocumentation, this.id, uuid_document)
                .then(res => {
                    const link = document.createElement('a');
                    link.href = URL.createObjectURL(res);
                    link.download = fileName;
                    document.body.append(link);
                    link.click();
                    link.remove();
                    window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
                })
                .catch(err => {
                    this.$toast.error(`Error ${err.name}`, `${err.message}`);
                    console.error(err);
                })
                .finally(() => {
                    const index = this.activeDownloads.indexOf(uuid_document);
                    if (index > -1) {
                        this.activeDownloads.splice(index, 1);
                    }
                });
        },

        /**
         * ASIGNACIÓN DE ARCHIVO PARA ELIMINAR
         * Asignamos la información del archivo en una variable para poder asignarlo al modal
         * @param {Object} item Información del archivo
         */
        assignIdDocumentToDelete(item) {
            this.documentToDelete = item;
        },

        /**
         * ELIMIAR ARCHIVO
         * Acción para eliminar el archivo una vez se confirma en el modal
         */
        removeDocument() {
            documentsService.removeDocument(this.typeDocumentation, this.id, this.documentToDelete.uuid)
                .then(() => {
                    this.$root.$emit(`refresh_${this.typeDocumentation}`);
                    this.$toast.success(`Documento eliminado`, `El documento se ha eliminado con éxito.`);
                })
                .catch(err => {
                    this.$toast.error(`Error ${err.name}`, `${err.message}`);
                    console.error(err);
                })
                .finally(() => this.hideModal('modalRemoveDocument'));
        },

        /**
         * SUBIDA ARCHIVOS CORRECTA
         * Método llamado al lanzar el emit desde el componente upload-documents
         */
        uploadOk() {
            this.uploadDocument = false;
            this.fetchData();
        }
    },
    computed: {
        canDeleteIt() {
            return true;
        }
    },
    /**
     * @override
     */
    beforeMount() {
        if (!this.type) {
            switch (this.$route.name) {
                case 'account_documentation_uuid_view':
                    this.typeDocumentation = 'account';
                    break;
                case 'operation_documentation_uuid_view':
                    this.typeDocumentation = 'operation';
                    break;
                default:
                    this.typeDocumentation = 'intervener';
                    break;
            }
        } else {
            this.typeDocumentation = this.type;
        }
        switch (this.typeDocumentation) {
            case 'account':
                this.linkMoreInformation = 'account_documentation_uuid_view';
                break;
            case 'operation':
                this.linkMoreInformation = 'operation_documentation_uuid_view';
                break;
            case 'intervener':
                this.linkMoreInformation = 'intervener_documentation_uuid_view';
                break;
            default:
                break;
        }
        this.uuid_account = this.uuid || this.$route.params.uuid;
        this.files = {
            fields: [
                {
                    key: 'title',
                    label: 'Título'
                },
                {
                    key: 'document_category',
                    label: 'Categoría'
                },
                {
                    key: 'document_subcategory',
                    label: 'Subcategoría'
                },
                {
                    key: 'document_uri',
                    label: 'Documento',
                    tdClass: 'link'
                },
                {
                    key: 'created_on',
                    label: 'Fecha de subida'
                },
                {
                    key: 'updated_on',
                    label: 'Fecha de actualización'
                },
                {
                    key: 'actions',
                    label: '',
                    class: 'actions'
                }
            ],
            items: []
        };
        this.fetchData();
    }
};
